<template>
  <div class="registration_form">
    <el-form
      :model="query"
      ref="lefts"
      style="margin:0 15px 42px 0;"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="中文姓名" prop="name">
        <el-input :disabled="disabledNormal" v-model="query.name" placeholder="请输入中文姓名"></el-input>
      </el-form-item>
      <el-form-item label="汉语拼音" prop="nameSpell">
        <el-input :disabled="disabledNormal" placeholder="请输入汉语拼音" v-model="query.nameSpell"></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" prop="political">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.political"
          placeholder="请选择"
        >
          <el-option label="团员" :value="1"></el-option>
          <el-option label="党员" :value="2"></el-option>
          <el-option label="民主党派" :value="3"></el-option>
          <el-option label="群众" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生年月" prop="birthday">
        <el-date-picker
          :disabled="disabledNormal"
          v-model="query.birthday"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="移动电话" prop="phone">
        <el-input :disabled="isDisabled" v-model="query.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <template v-if="!disabledNormal">
        <el-form-item label class="rows">
          <el-select
            :disabled="disabledNormal"
            @change="selectCard"
            :popper-append-to-body="false"
            placeholder="身份证号"
            v-model="query.card"
          >
            <el-option label="身份证号" :value="0"></el-option>
            <el-option label="港澳证号" :value="1"></el-option>
            <el-option label="台湾证号" :value="2"></el-option>
          </el-select>
          <el-form class="cards_box" :model="query" ref="cards">
            <el-form-item
              label=" "
              prop="idCard"
              class="id_card"
              :rules="[
        {required:true,validator:cardValidate,trigger:'blur'}]"
            >
              <el-input :disabled="isDisabled" v-model="query.idCard" placeholder="请输入证件号码"></el-input>
            </el-form-item>
          </el-form>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item
          label="身份证号"
          prop="idCard"
          :rules="[{required:true,message:'证件号码不能为空',trigger:'blur'}]"
        >
          <el-input disabled v-model="query.idCard" placeholder="请输入证件号码"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <el-form :model="query" ref="rights" :rules="rules" label-width="55px">
      <el-form-item label="民族" prop="nation">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.nation"
          filterable
          placeholder="请选择民族"
        >
          <el-option
            v-for="(item,index) in nationList"
            :key="index"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.gender"
          placeholder="请选择性别"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身高" prop="height">
        <el-input :disabled="isDisabled" v-model="query.height" placeholder="请输入身高">
          <span class="unit" slot="suffix">cm</span>
        </el-input>
      </el-form-item>
      <el-form-item label="体重" prop="weight">
        <el-input :disabled="isDisabled" placeholder="请输体重" v-model="query.weight">
          <span class="unit" slot="suffix">kg</span>
        </el-input>
      </el-form-item>
      <el-form-item label="血型">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.bloodType"
          clearable
          placeholder="请选择血型"
        >
          <el-option label="A型" :value="1"></el-option>
          <el-option label="B型" :value="2"></el-option>
          <el-option label="O型" :value="3"></el-option>
          <el-option label="AB型" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="鞋码" prop="shoesSize">
        <el-input :disabled="isDisabled" v-model="query.shoesSize" placeholder="请输入鞋码">
          <span class="unit" slot="suffix">码</span>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="user_img">
      <div class="empty">
        <img v-if="headImage " style="width:100%;height:100%" :src="headImage " alt />
        <template v-else>
          <i class="el-icon-user-solid" font-size="40px"></i>
          <p>2寸近照</p>
        </template>
      </div>
      <el-upload
        :style="{visibility:!isDisabled?'visible':'hidden'}"
        class="upload-demo"
        accept="image/jpeg, image/jpg, image/png"
        action="//up-z1.qiniup.com"
        :show-file-list="false"
        :before-upload="handleBefore"
        :on-success="uploadSuccess"
        :data="{token: uptoken}"
      >
        <el-button
          :loading="loading"
          style="color:#1E63B0;border-color:#1E63B0;margin-top:20px"
        >上传照片</el-button>
      </el-upload>
    </div>
    <el-form
      style="position:absolute;bottom:16px;left:0;width:calc(100% - 335px)"
      :model="query"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item class="address" label="运动员等级" :style="{width:operation?'100%':''}">
        <el-input :disabled="isDisabled" placeholder="请输入运动员等级" v-model="query.athleteRank"></el-input>
      </el-form-item>
      <el-form-item class="address" label="本人最好成绩" :style="{width:operation?'100%':''}">
        <el-input :disabled="isDisabled" placeholder="请输入" v-model="query.bestScore"></el-input>
      </el-form-item>
    </el-form>
    <el-dialog
      width="500px"
      title="操作提示"
      center
      :close-on-click-modal="false"
      :visible.sync="tipDialogVisible"
      :modal-append-to-body="false"
      append-to-body
    >
      <div class="modal_content">
        <i class="el-icon-warning"></i>
        <section>
          <p>无法完成操作！</p>
          <p>照片大小请限制在 1 MB以内。</p>
        </section>
      </div>
      <div class="footer_modal">
        <el-button style="width:90px" type="primary" @click="closeTips">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
import { rule } from "@/utils/utils";
export default {
  props: {
    uptoken: {
      type: String
    },
    formInfo: {
      type: Object
    },
    operation: {
      type: String
    }
  },
  watch: {
    formInfo(value) {
      if (value) {
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }
        this.headImage = this.query.headImage;
      }
    }
  },
  data() {
    return {
      loading: false,
      files: "",
      headImage: "",
      query: {
        name: "",
        nameSpell: "",
        gender: "",
        political: "", //政治面貌
        height: "",
        birthday: "",
        weight: "",
        card: 0, //证件号类型
        idCard: "",
        phone: "",
        athleteRank: "",
        bestScore: "",
        headImage: "", //寸照
        shoesSize: "", //鞋码
        bloodType: "", //血型
        nation: "" //民族
      },
      rules: {
        name: [{ required: true, validator: rule.name, trigger: "blur" }],
        nameSpell: [
          { required: true, validator: rule.nameSpell, trigger: "blur" }
        ],
        nation: [{ required: true, validator: rule.nation, trigger: "change" }],
        gender: [{ required: true, validator: rule.gender, trigger: "change" }],
        political: [
          { required: true, validator: rule.political, trigger: "change" }
        ],
        birthday: [
          {
            type: "date",
            required: true,
            validator: rule.birthday,
            trigger: "change"
          }
        ],
        height: [{ required: true, validator: rule.height, trigger: "blur" }],
        shoesSize: [{ validator: rule.shoesSize, trigger: "blur" }],
        weight: [{ required: true, validator: rule.weight, trigger: "blur" }],
        education: [
          { required: true, validator: rule.education, trigger: "change" }
        ],
        phone: [{ required: true, validator: rule.phone, trigger: "blur" }]
      },
      tipDialogVisible: false
    };
  },
  computed: {
    // 根据证件类型切换证件号验证规则
    cardValidate() {
      return (rule, value, cb) => {
        if (!value) {
          return cb(new Error("证件号不能为空"));
        }
        if (
          this.query.card === 0 &&
          !/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/.test(
            value
          )
        ) {
          return cb(new Error("证件号格式错误"));
        }
        if (this.query.card === 1 && !/^[0-9a-zA-Z]{9}$/.test(value)) {
          return cb(new Error("证件号格式错误!"));
        }
        if (this.query.card === 2 && !/^[0-9a-zA-Z]{8}$/.test(value)) {
          return cb(new Error("证件号格式错误!"));
        }
        cb();
      };
    },
    // 判断是否禁用表单组件输入
    isDisabled() {
      return this.operation === "watch" ? true : false;
    },
    //
    isShowBtn() {
      if (this.formInfo) {
        if (this.formInfo.state === 4 || this.formInfo.state === 2) {
          return true;
        }
        return this.operation === "watch" ? true : false;
      }
      return false;
    },
    // 默认项不可修改
    disabledNormal() {
      if (this.operation === "watch") return true;
      if (this.formInfo && this.formInfo.name) {
        if (
          this.formInfo.state === 0 ||
          this.formInfo.state === 2 ||
          this.formInfo.state === 4
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    nationList() {
      return registerData.nationList;
    },
    projectList() {
      return registerData.projectList;
    }
  },
  methods: {
    // 选择证件类型
    selectCard(value) {
      this.query.idCard = "";
      let _field = this.$refs["cards"].fields; /*当然，你可以打印一下fields*/
      _field.map(i => {
        if (i.prop === "idCard") {
          //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
          i.resetField();
          return false;
        }
      });
    },
    // 关闭图片上传限制弹窗
    closeTips() {
      this.tipDialogVisible = false;
    },
    // 表单提交验证
    submits() {
      if (this.$refs["cards"]) {
        return Promise.all([
          this.$refs["lefts"].validate(),
          this.$refs["cards"].validate(),
          this.$refs["rights"].validate()
        ])
          .then(res => {
            if (!this.query.headImage) {
              this.$message.warning("请上传2寸照片");
              return null;
            }
            return Promise.resolve(this.query);
          })
          .catch(err => {
            this.$message.warning("请完善运动员基本信息");
            return null;
          });
      } else {
        return Promise.all([
          this.$refs["lefts"].validate(),
          this.$refs["rights"].validate()
        ])
          .then(res => {
            if (!this.query.headImage) {
              this.$message.warning("请上传2寸照片");
              return null;
            }
            return Promise.resolve(this.query);
          })
          .catch(err => {
            this.$message.warning("请完善运动员基本信息");
            return null;
          });
      }
    },
    // 重置表单
    resetForm() {
      this.$refs["lefts"].resetFields();
      this.$refs["cards"].resetFields();
      this.$refs["rights"].resetFields();
    },
    handleBefore(file) {
      this.files = file;
      this.loading = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 1; //图片大小不超过2MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        return false;
      }
      if (!isLt5M) {
        // this.$message.error("上传图片大小不能超过 5M!");
        this.tipDialogVisible = true;
        this.loading = false;
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.loading = false;
      this.$message.success("上传成功！");
      this.query.headImage = response.key;
      this.headImage = window.URL.createObjectURL(this.files);
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
@media (min-width: 1920px) {
  .registration_form {
    /deep/ .address {
      width: 92%;
    }
    /deep/ .rows {
      .el-select {
        width: 124px;
      }
      .cards_box {
        width: 100%;
      }
    }
  }
}
@media (min-width: 200px) and (max-width: 1919px) {
  .registration_form {
    /deep/ .rows {
      .el-select {
        width: 90px;
      }
      .cards_box {
        width: calc(100% - 90px);
      }
    }
  }
}
@media (min-width: 900px) and( max-width: 1919px) {
  .registration_form {
    /deep/ .address {
      width: 100%;
    }
  }
}
.registration_form {
  position: relative;
  display: flex;
  padding: 40px 20px 40px 0;
  justify-content: space-between;
  /deep/ .rows {
    > .el-form-item__content {
      display: flex;
      margin-left: 20px !important;
    }

    .el-select {
      .el-input--suffix .el-input__inner {
        padding: 0 25px 0 5px;
      }
    }
  }
  /deep/ .id_card {
    margin-left: 10px;
    > .el-form-item__label {
      width: 10px !important;
      padding-right: 5px;
      position: absolute;
      left: -10px;
      top: 0;
    }
    > .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
  .unit {
    color: #333;
    font-size: 14px;
    padding-right: 5px;
  }
  .user_img {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .empty {
    width: 295px;
    height: 412px;
    background: #d8d8d8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    > p {
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>